import { customElement, resolve } from 'aurelia';
import { I18N } from '@aurelia/i18n';
import template from './rules-list.html';
import { listRules, deleteRule } from '../services/api.service';
import type { Rule } from '../services/api.types';
import { ConfirmDialog } from '../components/confirm-dialog';

@customElement({ name: 'rules-list', template })
export class RulesList {
  private readonly i18n: I18N = resolve(I18N);

  public rules: Rule[] = [];
  public errorMessage = '';
  public showModal = false;
  public ruleToEdit: Rule | null = null;

  public async loading(): Promise<void> {
    await this.fetchRules();
  }

  public async fetchRules(): Promise<void> {
    try {
      this.rules = await listRules();
    } catch (e: unknown) {
      this.errorMessage = e instanceof Error ? e.message : String(e);
    }
  }

  public openCreateModal(): void {
    this.ruleToEdit = null;
    this.showModal = true;
  }

  public openEditModal(rule: Rule): void {
    this.ruleToEdit = rule;
    this.showModal = true;
  }

  public onModalSaved(rule: Rule): void {
    const idx = this.rules.findIndex(r => r.id === rule.id);
    if (idx >= 0) {
      this.rules[idx] = rule;
      this.rules = [...this.rules];
    } else {
      this.rules = [...this.rules, rule];
    }
    this.showModal = false;
    this.ruleToEdit = null;
  }

  public onModalClosed(): void {
    this.showModal = false;
    this.ruleToEdit = null;
  }

  public async removeRule(rule: Rule): Promise<void> {
    const confirmed = await ConfirmDialog.confirm(
      this.i18n.tr('rules.delete.confirm', { title: rule.title }),
      this.i18n.tr('rules.delete.confirmTitle')
    );
    if (!confirmed) return;
    try {
      await deleteRule(rule.id);
      this.rules = this.rules.filter(r => r.id !== rule.id);
    } catch (e: unknown) {
      this.errorMessage = e instanceof Error ? e.message : String(e);
    }
  }
}
